module.exports = __webpack_public_path__ + "img/builder-19.0baf6d67.webp";